module.exports = __webpack_public_path__ + "static/media/add-cover-photo.14b81332.svg";